import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { login } from "@/lib/auth";
import { Loader2 } from "lucide-react";
import { BrandLogo } from "@/components/rikkus/BrandLogo";

export default function LoginPage() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const nav = useNavigate();

    const onSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await login(email.trim(), password);
            toast.success("Autenticado");
            nav("/audit", { replace: true });
        } catch (err) {
            const msg = err?.response?.data?.detail || err.message || "Error de login";
            toast.error(String(msg));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen w-full flex items-center justify-center bg-background text-foreground px-4">
            <div className="w-full max-w-sm">
                <div className="mb-8 text-left space-y-3">
                    <BrandLogo
                        variant="auto"
                        imgClassName="h-10 w-auto"
                        data-testid="login-brand-logo"
                    />
                    <div className="text-[11px] font-mono text-primary uppercase tracking-[0.2em]">
                        Precisión en movimiento
                    </div>
                    <div className="text-[10px] font-mono text-muted-foreground uppercase tracking-widest">
                        panel — fase sombra
                    </div>
                </div>
                <Card className="border-border">
                    <CardHeader className="pb-3">
                        <CardTitle className="text-base">Iniciar sesión</CardTitle>
                        <CardDescription className="text-xs">Herramienta interna. Usa las credenciales del panel.</CardDescription>
                    </CardHeader>
                    <CardContent>
                        <form data-testid="login-form" onSubmit={onSubmit} className="space-y-3">
                            <div className="space-y-1.5">
                                <Label htmlFor="login-email" className="text-xs">Email</Label>
                                <Input
                                    id="login-email"
                                    data-testid="login-email-input"
                                    type="email"
                                    autoComplete="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    className="h-9"
                                    required
                                />
                            </div>
                            <div className="space-y-1.5">
                                <Label htmlFor="login-password" className="text-xs">Password</Label>
                                <Input
                                    id="login-password"
                                    data-testid="login-password-input"
                                    type="password"
                                    autoComplete="current-password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    className="h-9"
                                    required
                                />
                            </div>
                            <Button data-testid="login-submit-button" type="submit" className="w-full h-9" disabled={loading}>
                                {loading && <Loader2 className="h-4 w-4 animate-spin mr-2" />}
                                Entrar
                            </Button>
                        </form>
                    </CardContent>
                </Card>
                <p className="mt-4 text-[10px] font-mono text-muted-foreground text-center">
                    Todos los timestamps: UTC almacenado • ET mostrado
                </p>
            </div>
        </div>
    );
}
